import hash from "object-hash";

import type {
  AstGrepMatch,
  Widget,
  Query as WidgetQuery,
} from "@acme/validators";

const WIDGET_IGNORE_KEYS = new Set([
  "id",
  "__proto__",
  "constructor",
  "prototype",
]);

export const getWidgetHash = (widget: Widget) => {
  return hash({
    type: widget.type,
    queries: widget.queries.map(getWidgetQueryHash),
    timeRange: widget.type === "timeseries" ? widget.timeRange : undefined,
  });
};

export const getWidgetQueryHash = (query: WidgetQuery) => {
  return hash(query, {
    ignoreUnknown: true,
    excludeKeys: (key) => {
      return WIDGET_IGNORE_KEYS.has(key);
    },
  });
};

export const getAstGrepMatchesHash = (matches: AstGrepMatch<unknown>[]) => {
  return hash(matches, {
    ignoreUnknown: true,
    excludeKeys: (key) => {
      return key === "id";
    },
  });
};
